import React from 'react';
import styles from './style.module.css';
import StepThreeForm from '../../components/forms/step-three';

export default () => (
    <div className={styles.page}>
        <p className={styles.topTitle}>Loan Intro Title</p>
        <h1 className={styles.mainTitle}>Consumer Loans</h1>
        <p className={styles.text}>Content relating to the options for consumer loans.</p>
        <StepThreeForm/>
    </div>
);
